import type { ILiquidSeriesTheme } from '../../../../series/liquid/interface';

export const liquid: ILiquidSeriesTheme = {
  outlinePadding: 10,
  liquidBackground: {
    style: {
      lineWidth: 0,
      fillOpacity: 0.2
    }
  },
  liquidOutline: {
    style: {
      lineWidth: 2
    }
  }
};
